export const name = "CSCH";
export const summary = `Computes the hyperbolic cosecant of \`X\`.`;
export const reference = `
## CSCH

Computes the hyperbolic cosecant of \`X\`.

\`\`\`
CSCH(X)
\`\`\`

### Description

Computes the hyperbolic cosecant of the input angle, which is in radians.\`X\` can be any data type that coerces to \`FLOAT64\`. Supports the \`SAFE.\` prefix.

| X | CSCH(X) |
| --- | --- |
| \`+inf\` | \`0\` |
| \`-inf\` | \`0\` |
| \`NaN\` | \`NaN\` |
| \`0\` | \`Error\` |
| \`NULL\` | \`NULL\` |


### Return Data Type

\`FLOAT64\`


### Example



\`\`\`
SELECT CSCH(0.5) AS a, CSCH(-2) AS b, SAFE.CSCH(0) AS c;

/*----------------+----------------+------*
 | a | b | c |
 +----------------+----------------+------+
 | 1.919034751334 | -0.27572056477 | NULL |
 *----------------+----------------+------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
